if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      this.formerDesignSubmitButton = document.getElementById('open-template-customize-modal');
      this.isBulkOrder = this.getFormType()
      this.productTitle = this.getProductTitle()
      this.isBallMarker = this.getBallMarkerClass()
      this.customPromo = this.getCustomPromo()
      this.isTeamStores = this.getIsTeamStores();
      this.current_store = this.getAttribute('data-current-store');
      this.productCustomizationRequired = this.getAttribute('data-product-customization');
      this.productType = this.getAttribute('data-product-type');

      // Remove error message on file input change
      const fileInput = this.querySelector('input[type="file"][name="properties[New Image]"]');
      if (fileInput) {
        fileInput.addEventListener('change', () => {
          if (fileInput.files.length > 0) {
            this.handleErrorMessage(false);
          }
        });
      }
    }

    getIsSpecialOrder(){
      for(const key in Shopify.current_product['tags']){
        if(Shopify.current_product['tags'][key] === 'specialorder'){
          return true;
        }
      }
      return false;
    }

    getProductTitle(){
      const productTitle = document.querySelector('.product__title h1').innerText
      return productTitle
    }

    getFormType(){
      const isBulkOrder = document.querySelector('#bulk-order-form')
      if(isBulkOrder === null){
        return false
      } else {
        return true
      }
    }

    // Function to check if the form has the "teamstores-form" class
    getIsTeamStores() {
      return this.form.classList.contains('teamstores-form');
    }

    getCustomPromo(){
      const element = document.querySelector('.main-product');
      if (element && element.classList.contains('EMBROIDERY0')) {
        return 'EMBROIDERY0';
      } 
      else if (element && element.classList.contains('EMBROIDERY3')) {
        return 'EMBROIDERY3';
      } 
      else if (element && element.classList.contains('EMBROIDERY6')) {
        return 'EMBROIDERY6';
      } else {
        return 'none';
      }
    }
    
    getBallMarkerClass(){
      const element = document.querySelector('.main-product');
      if (element && element.classList.contains('ball-markers')) {
        return true;
      } else {
        return false;
      }
    }

    // Get customized template information
    getTemplateCustomizationProperties(){
      const templateForm = document.getElementById("template-customization-form")
      const formData = new FormData(templateForm)
      const formEntries = formData.entries()
      
      const lineItemProperties = {}

      for(const entry of formEntries){
        const key = entry[0]
        const value = entry[1]
        // Don't add empty embroidery file input
        if(key == 'New Image'){
          if(value.name != ''){
            lineItemProperties[key] = value
          }
        }
        else if(key == 'Ball Pocket New Image'){
          if(value.name != ''){
            lineItemProperties[key] = value
          }
        }
        else if(value != ''){
          lineItemProperties[key] = value
        }
      }

      let selectedEmbroideryImage = document.querySelector('input[name="library-image"]:checked')
      if(selectedEmbroideryImage){
        let artSetupId = selectedEmbroideryImage.getAttribute('data-art-setup-id')
        if(artSetupId){
          lineItemProperties["Art Setup Id"] = artSetupId
        }
      }

      let designSource = templateForm.getAttribute('data-design-source');
      if (designSource) {
        lineItemProperties['design-source'] = designSource;
      }

      const selectedDesign = document.querySelector('#step-2a input[name="design"]:checked~label img')
      if(selectedDesign != null){
        lineItemProperties['design_src'] = selectedDesign.src
      }
      return lineItemProperties
    }

    addCustomizedTemplateToCart(){
      // if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.showLoadingFDB();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      if(this.isBulkOrder === true){
        this.addBulkOrder(formData, true)
      } else {
        this.addSingleItem(formData, config)
      }
    }

    validateArtSetupFee(){
      const image_upload = document.getElementById('new-image').value
      if(image_upload){
        return true
      } else {
        this.handleErrorMessage("You must upload an image.")
        return false
      }
    }

    validateCustomizationType() {
      const customizationType = document.getElementById('customization-type').value;
      if (customizationType !== "") {
        return true;
      } else {
        this.handleErrorMessage("You must select a Customization Type.");
        return false;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if(this.productTitle.toLowerCase() == 'art setup fee'){
        if(this.validateArtSetupFee() == false || this.validateCustomizationType() == false){
          return
        }
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.showLoading();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      if(this.isBulkOrder === true){
        const activeMediaItem = document.querySelector('.team-store-design.active');
        if (this.isTeamStores === true) {
          const isClassicForm = false;
          const isTeamStores = this.isTeamStores
          const teamStoreDesigns = document.querySelectorAll('.team-store-design');
          if (teamStoreDesigns.length > 0 && !activeMediaItem && this.productType !== 'Art Setup Fee') { 
            this.hideLoading();
            return alert("You must select a Design.");
            // return this.handleErrorMessage("You must select a Design.");
          }

          this.addBulkOrder(formData, isClassicForm, isTeamStores)
        } else {
          // const designRequired = this.productCustomizationRequired === "true";
          if(!activeMediaItem && this.productType !== 'Art Setup Fee'){
              this.hideLoading();
              return alert("You must select a Design.");
            }
          this.addBulkOrder(formData)
        }
      } else {
        this.addSingleItem(formData, config)
      }

      // window.variantColorRadios?.resetQty();
    }

    addBulkOrder(formData, isCustomizedTemplate, isTeamStores){
    // addBulkOrder(formData, isCustomizedTemplate){

       let form_body = {
        'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname,
        'form_type': "product",
        'utf8': "✓",
        'items': []
      }

      let customizationId = null
      if(isCustomizedTemplate){
        // Set the customization id for items added to the cart. This is used to match the fee with products
        customizationId = Date.now()
      }

      let form_entries = formData.entries()

      // Loop through form entries
      for(const entry of form_entries){

        // If Bulk Order Entry
        if(entry[0].endsWith("qty")){

          // Get variant id and qty
          const variant_id = entry[0].split("-")[0]
          const variant_qty = entry[1]

          let customizable = 'false';
          if (isTeamStores && document.querySelector('.team-store-design.active') && document.querySelector('.team-store-design.active').getAttribute('data-tsdesign-name') != 'blank') {
            customizable = document.querySelector('.color-option.active').querySelector('.color-swatch-box ').getAttribute('data-customizable');
          }

          const activeMediaItem = document.querySelector('.team-store-design.active');

          // If qty is not zero, add it to cart
          if(variant_qty != 0){
            const variant_qty_in_stock = document.querySelector(`.color-sizes-current-qty[data-variant-qty-input='${entry[0]}'`).innerText
            // const variant_qty_special_order = document.querySelector(`.color-sizes-special-order-qty[data-variant-qty-input='${entry[0]}'`).innerText

            // Set the variant, qty
            const a_variant = {
              'id': variant_id,
              'quantity': variant_qty
            }

            a_variant['properties'] = {}
            let isSpecialOrder = this.getIsSpecialOrder();

            if(variant_qty > variant_qty_in_stock && isSpecialOrder){
              a_variant['properties']['_special_order'] = true
            }
            else{
              a_variant['properties']['_special_order'] = false
            }

            // Add to cart blank and skip
            if(isCustomizedTemplate){
              // Get line item properties for templates
              const customization_properties = this.getTemplateCustomizationProperties(a_variant['properties'])

              a_variant['properties'] = {...a_variant['properties'], ...customization_properties}
              a_variant['properties']['Customization Id'] = `${customizationId}-${variant_id}`
              // a_variant['properties']['Customization Id'] = `${customizationId}`

              if("New Image" in a_variant['properties'] || "Ball Pocket New Image" in a_variant['properties']){
                a_variant['properties']['Art Setup Id'] = customizationId
              }

              if("New Image" in a_variant['properties'] && "Ball Pocket New Image" in a_variant['properties']){
                a_variant['properties']['Art Setup Id 2'] = `${customizationId}-2`
              }

              let designSource = null;
              const templateForm = document.getElementById("template-customization-form");
              if (templateForm) {
                designSource = templateForm.getAttribute('data-design-source');
              }
              // Add product
              form_body.items.push(a_variant)

              // Add customization fee
              const customization_fee = {
                'id': '44219688779963',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource

                }
              }

              if("design_src" in a_variant['properties']){
                customization_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                customization_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                customization_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }

              // Add embroidery fee                
              const embroidery0_fee = {
                'id': '46266070728891',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                embroidery0_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                embroidery0_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                embroidery0_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }
              
              const embroidery3_fee = {
                'id': '46266070761659',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                embroidery3_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                embroidery3_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                embroidery3_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }
              
              const embroidery6_fee = {
                'id': '46051408642235',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                embroidery6_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                embroidery6_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                embroidery6_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }

              // Add Direct to Garment Fee - 44782655111355
              const dtg_fee = {
                'id': '44782655111355',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                dtg_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                dtg_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                dtg_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }

              // Add Heat Transfer Fee - 44781012844731
              const heat_transfer_fee = {
                'id': '44781012844731',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                heat_transfer_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                heat_transfer_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                heat_transfer_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }

              // Add Sublimation Fee - 44782705410235
              const sublimation_fee = {
                'id': '44782705410235',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                sublimation_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                sublimation_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                sublimation_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }

              // Add Ball Marker Customization Fee - 44803850993851
              const ball_marker_fee = {
                'id': '44803850993851',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }
              
              if("design_src" in a_variant['properties']){
                ball_marker_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                ball_marker_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                ball_marker_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              } 

              // Add DTF Fee - 45278167761083
              const dtf_fee = {
                'id': '45278167761083',
                'quantity': variant_qty,
                'properties': {
                  'Customization Id': `${customizationId}-${variant_id}`,
                  'design-source' : designSource
                }
              }

              if("design_src" in a_variant['properties']){
                dtf_fee['properties']['design_src'] = a_variant['properties']["design_src"]
              } else if("New Image" in a_variant['properties']){
                dtf_fee['properties']['New Image'] = a_variant['properties']["New Image"]
              } else if("library-image" in a_variant['properties']){
                dtf_fee['properties']['library-image'] = a_variant['properties']["library-image"]
              }
              
              // Push Form Data
              if(a_variant['properties']["customization-type"] == "embroidery"){
                if(this.customPromo == 'EMBROIDERY0') form_body.items.push(embroidery0_fee)
                else if (this.customPromo == 'EMBROIDERY3') form_body.items.push(embroidery3_fee)
                else form_body.items.push(embroidery6_fee)
              } else if(a_variant['properties']["customization-type"] == "direct to garment"){
                form_body.items.push(dtg_fee) 
              } else if(a_variant['properties']["customization-type"] == "heat"){
                form_body.items.push(heat_transfer_fee)
              } else if(a_variant['properties']["customization-type"] == "sublimation"){
                form_body.items.push(sublimation_fee)
              } else if(a_variant['properties']["customization-type"] == "direct to film"){
                form_body.items.push(dtf_fee)
              } else {
                if(this.isBallMarker){
                  form_body.items.push(ball_marker_fee)
                } else {
                  form_body.items.push(customization_fee)
                }
              }
            } else if (this.current_store == "Golf Team Products" || this.current_store == "GTPPlus") {
              // ONE CLICK CUSTOMISATION DATA
              const isUserLoggedIn = this.form.querySelector('[data-user-logged-in]').getAttribute('data-user-logged-in') === 'true';

              // Redirect if not logged in
              if (!isUserLoggedIn) {
                  window.location.href = "/account/login";
                  return; // Stop further execution
              }
            
              // Current Store Design Image
              let designName = null;
              let designSource = null;
              if(activeMediaItem) {
                designName = activeMediaItem.getAttribute('data-tsdesign-name');
                designSource = activeMediaItem.getAttribute('data-design-source');
              }
              const isBlankOrNoLogo = !activeMediaItem || designName === "blank";

              if (isBlankOrNoLogo) {
                const a_variant_blank = {
                  'id': variant_id,
                  'quantity': variant_qty
                }
                form_body.items.push(a_variant_blank);
                // continue
              } else {
                let mascotImageSrc
                if (activeMediaItem) {
                  const mascotImage = activeMediaItem.querySelector('img');
                  mascotImageSrc = mascotImage.getAttribute('src');
                }

                // Current Store Customization ID data
                const customizationDataElement = document.getElementById('customization-id-data');
                const customizationData = customizationDataElement.getAttribute('data-customization-id');
                const customizationObj = JSON.parse(customizationData);
                
                const jcActiveImage = document.querySelector('.product__media-item.is-active');
                const jcCustomization = jcActiveImage.querySelector('[data-customization]');
                const jccustomizationData = jcCustomization.getAttribute('data-customization');

                const jcCustomizationId = jcActiveImage.querySelector('[data-customization-id]');
                const jccustomizationIdData = jcCustomizationId.getAttribute('data-customization-id');
                
                const jcActiveDesign = document.querySelector('.color-option.active');
                const jcActiveDesignLabel = jcActiveDesign.querySelector('.color-swatch-box');
                const jcActiveDesignData = jcActiveDesignLabel.getAttribute('data-active-design');
                const jcVariantImageData = jcActiveDesignLabel.getAttribute('data-teamstore-image');

                let jcCustomizationDataJSON = {};
                jcCustomizationDataJSON = JSON.parse(jccustomizationData.replace(/'/g, '"'));
                a_variant['properties'].MaxWidth = jcCustomizationDataJSON['design_info'][0]['MaxWidth']
                a_variant['properties'].MaxHeight = jcCustomizationDataJSON['design_info'][0]['MaxHeight']
                a_variant['properties'].designCenter = jcCustomizationDataJSON['design_info'][0]['designCenter']
                a_variant['properties'].designHeight = jcCustomizationDataJSON['design_info'][0]['designHeight']

                // Design Source Info
                a_variant['properties']['design-source'] = designSource

                let jcCustomizationIdDataJSON = {};
                jcCustomizationIdDataJSON = JSON.parse(jccustomizationIdData.replace(/'/g, '"'));

                a_variant['properties'].design_alignment = jcCustomizationIdDataJSON.design_alignment;
                a_variant['properties'].design_scaling_method = jcCustomizationIdDataJSON.design_scaling_method;
                a_variant['properties'].active_design = jcActiveDesignData;
                a_variant['properties'].variant_image = jcVariantImageData;

                // Get the checked input radio
                const selectedColor = document.querySelector('input[name="Color"]:checked');
                const dataSkuThreadColor = selectedColor.getAttribute('data-sku-thread-color');

                const location = customizationObj.location;
                const customerId = activeMediaItem.getAttribute('data-customer-id');
                const customizationType = activeMediaItem.getAttribute('data-customization-type');
                const mascotName = customizationObj.mascot_name;
                const designClassification = activeMediaItem.getAttribute('data-classification-group');

                customizationId = Date.now()
                const customizationIdFormatted_Logo = `${customizationId}-${variant_id}`

                let part1 = "";
                let part2 = "";
                let part3 = "";
                console.log('here we are');

                // Logic for part1: Mascot or School or empty
                if (designClassification === "mascot_specific") {
                    part1 = mascotName + "_";
                } else if (designClassification === "school_specific" || designClassification === "coach_specific") {
                    part1 = customerId + "_";
                } else {
                    part1 = ""; // General case
                }

                // Logic for part2: Design Name (common across all classifications)
                part2 = designName ? designName + "_" : "";

                // Only include part3 if designSource is not "on-click-logo"
                  part3 = dataSkuThreadColor ? dataSkuThreadColor + "_" : "";

                // Final customizationId combining all parts
                const customizationIdFormatted_Template = part1 + part2 + part3 + "_vid=" + variant_id;
                
                const customizationIdFormatted = designSource === "one-click-logo" ? customizationIdFormatted_Logo : customizationIdFormatted_Template
                
                a_variant['properties']['customer-id'] = customerId
                a_variant['properties']['Customization Id'] = customizationIdFormatted
                a_variant['properties']['location'] = location
                a_variant['properties']['customization-type'] = customizationType
                a_variant['properties']['design_ts'] = mascotImageSrc

                // Add Product
                  form_body.items.push(a_variant)

                  // Add customization fee
                  const customization_fee = {
                    'id': '44219688779963',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    customization_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }

                  // Add embroidery fee
                  const embroidery_fee = {
                    'id': '46266070728891',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    embroidery_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }

                  const embroidery3_fee = {
                    'id': '46266070761659',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    embroidery3_fee['properties']['design_ts'] = a_variant['properties']["design_ts"]
                  }

                  const embroidery6_fee = {
                    'id': '46051408642235',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    embroidery6_fee['properties']['design_ts'] = a_variant['properties']["design_ts"]
                  }

                  // Add Direct to Garment fee
                  const dtg_fee = {
                    'id': '44782655111355',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    dtg_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }

                  // Add Heat Transfer fee 
                  const heat_transfer_fee = {
                    'id': '44781012844731',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }
                  
                  if("design_ts" in a_variant['properties']){
                    heat_transfer_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }              

                  // Add Sublimation fee 
                  const sublimation_fee = {
                    'id': '44782705410235',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }

                  if("design_ts" in a_variant['properties']){
                    sublimation_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }   
                  
                  // Add DTF fee 
                  const dtf_fee = {
                    'id': '45278167761083',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }
                  
                  if("design_ts" in a_variant['properties']){
                    dtf_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }  
                  
                  // Add Ball Marker Customization fee
                  const ball_marker_fee = {
                    'id': '44803850993851',
                    'quantity': variant_qty,
                    'properties': {
                      'Customization Id': customizationIdFormatted,
                      'design-source' : designSource
                    }
                  }
                  
                  if("design_ts" in a_variant['properties']){
                    ball_marker_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                  }  

                  // Push Form Data
                  if(a_variant['properties']["customization-type"] == "embroidery"){
                    if(this.customPromo == 'EMBROIDERY0') form_body.items.push(embroidery_fee)
                    else if (this.customPromo == 'EMBROIDERY3') form_body.items.push(embroidery3_fee)
                    else form_body.items.push(embroidery6_fee) 
                  } else if(a_variant['properties']["customization-type"] == "direct to garment"){
                    form_body.items.push(dtg_fee) 
                  } else if(a_variant['properties']["customization-type"] == "heat"){
                    form_body.items.push(heat_transfer_fee)
                  } else if(a_variant['properties']["customization-type"] == "sublimation"){
                    form_body.items.push(sublimation_fee)
                  } else if(a_variant['properties']["customization-type"] == "direct to film"){
                    form_body.items.push(dtf_fee)
                  } else {
                    if(this.isBallMarker){
                      form_body.items.push(ball_marker_fee)
                    } else {
                      form_body.items.push(customization_fee)
                    }
                  }
              }
            } else if(isTeamStores && activeMediaItem && customizable === 'true') {
                const isUserLoggedIn = this.form.querySelector('[data-user-logged-in]').getAttribute('data-user-logged-in') === 'true';
                
                // Redirect if not logged in
                if (!isUserLoggedIn) {
                    window.location.href = "/account/login";
                    return; // Stop further execution
                }
                
                // Customization Type value for the TeamStores
                const customizationTypeInput = this.form.querySelector('input[name="customization-type"]');
                const customizationTypeValue = customizationTypeInput ? customizationTypeInput.value : null;

                // Teamstore Design Image
                const activeMediaItem = document.querySelector('.team-store-design.active');

                let mascotImageSrc;
                let designSource = null;
                if (activeMediaItem) {
                  const mascotImage = activeMediaItem.querySelector('img');
                  mascotImageSrc = mascotImage.getAttribute('src');
                  designSource = activeMediaItem.getAttribute('data-design-source');
                }

                // Teamstore Customization ID data
                const customizationDataElement = document.getElementById('customization-id-data');
                const customizationData = customizationDataElement.getAttribute('data-customization-id');
                const customizationObj = JSON.parse(customizationData);
                
                const jcActiveImage = document.querySelector('.product__media-item.is-active');
                const jcCustomization = jcActiveImage.querySelector('[data-customization]');
                const jccustomizationData = jcCustomization.getAttribute('data-customization');

                const jcCustomizationId = jcActiveImage.querySelector('[data-customization-id]');
                const jccustomizationIdData = jcCustomizationId.getAttribute('data-customization-id');
                
                const jcActiveDesign = document.querySelector('.color-option.active');
                const jcActiveDesignLabel = jcActiveDesign.querySelector('.color-swatch-box');
                const jcActiveDesignData = jcActiveDesignLabel.getAttribute('data-active-design');
                const jcTeamstoreImageData = jcActiveDesignLabel.getAttribute('data-teamstore-image');

                let jcCustomizationDataJSON = {};
                jcCustomizationDataJSON = JSON.parse(jccustomizationData.replace(/'/g, '"'));
                a_variant['properties'].MaxWidth = jcCustomizationDataJSON['design_info'][0]['MaxWidth']
                a_variant['properties'].MaxHeight = jcCustomizationDataJSON['design_info'][0]['MaxHeight']
                a_variant['properties'].designCenter = jcCustomizationDataJSON['design_info'][0]['designCenter']
                a_variant['properties'].designHeight = jcCustomizationDataJSON['design_info'][0]['designHeight']

                // Design Source Info
                a_variant['properties']['design-source'] = designSource

                let jcCustomizationIdDataJSON = {};
                jcCustomizationIdDataJSON = JSON.parse(jccustomizationIdData.replace(/'/g, '"'));

                a_variant['properties'].design_alignment = jcCustomizationIdDataJSON.design_alignment;
                a_variant['properties'].design_scaling_method = jcCustomizationIdDataJSON.design_scaling_method;
                a_variant['properties'].active_design = jcActiveDesignData;
                a_variant['properties'].teamstore_image = jcTeamstoreImageData;

                // Get the checked input radio
                const selectedColor = document.querySelector('input[name="Color"]:checked');
                const dataSkuThreadColor = selectedColor.getAttribute('data-sku-thread-color');

                const teamStoreId = customizationObj.team_store_id;
                const customerId = customizationObj.customer_id;
                const styleId = customizationObj.style_id;
                const garmentTeamColor = customizationObj.garment_team_color;
                const customizationType = customizationObj.customization_type;
                const mascotName = customizationObj.mascot_name;
                const location = customizationObj.location;
                const designName = activeMediaItem.getAttribute('data-tsdesign-name');
                const designClassification = activeMediaItem.getAttribute('data-classification-group');
                
                let apparelOrHeadwear = "";
                if(customizationType === "embroidery"){
                  apparelOrHeadwear = customizationObj.product_type;
                }

                let part1 = "";
                let part2 = "";
                let part3 = "";
                let part4 = "";

                // Logic for part1: Mascot or School or empty
                if (designClassification === "mascot_specific") {
                    part1 = mascotName + "_";
                } else if (designClassification === "school_specific" || designClassification === "coach_specific") {
                    part1 = teamStoreId + "_";
                } else {
                    part1 = ""; // General case
                }

                // Logic for part2: Design Name (common across all classifications)
                part2 = designName ? designName + "_" : "";
                
                // Logic for part3 and part4 based on customizationType
                if (customizationType === "embroidery") {
                    // Embroidery logic
                    if (designClassification === "mascot_specific" || designClassification === "general") {
                        part3 = dataSkuThreadColor; // Mascot or General uses skuThreadColor
                    } else if (designClassification === "school_specific" || designClassification === "coach_specific") {
                        part3 = apparelOrHeadwear; // School uses apparelOrHeadwear
                    }
                    // No need for part4 as it's only used for print
                } else {
                    part3 = styleId + "_"; // All print cases use styleId
                    part4 = garmentTeamColor; // All print cases use garmentTeamColor
                }

                // Final customizationId combining all parts
                const customizationIdFormatted = part1 + part2 + part3 + part4 + "_vid=" + variant_id;
                
                a_variant['properties']['teamstore-id'] = teamStoreId
                a_variant['properties']['customer-id'] = customerId
                a_variant['properties']['Customization Id'] = customizationIdFormatted
                a_variant['properties']['location'] = location
                a_variant['properties']['customization-type'] = customizationTypeValue
                a_variant['properties']['design_ts'] = mascotImageSrc
                //a_variant['properties']['design_info'] = JSON.stringify(jcCustomizationDataJSON)
                
                // Add Product
                form_body.items.push(a_variant)

                // Add customization fee
                const customization_fee = {
                  'id': '44219688779963',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }

                if("design_ts" in a_variant['properties']){
                  customization_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }

                // Add embroidery fee
                const embroidery_fee = {
                  'id': '46266070728891',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }

                if("design_ts" in a_variant['properties']){
                  embroidery_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }

                // Add Direct to Garment fee
                const dtg_fee = {
                  'id': '44782655111355',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }

                if("design_ts" in a_variant['properties']){
                  dtg_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }

                // Add Heat Transfer fee 
                const heat_transfer_fee = {
                  'id': '44781012844731',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }
                
                if("design_ts" in a_variant['properties']){
                  heat_transfer_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }              

                // Add Sublimation fee 
                const sublimation_fee = {
                  'id': '44782705410235',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }

                if("design_ts" in a_variant['properties']){
                  sublimation_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }   
                
                // Add DTF fee 
                const dtf_fee = {
                  'id': '45278167761083',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }
                
                if("design_ts" in a_variant['properties']){
                  dtf_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }  
                
                // Add Ball Marker Customization fee
                const ball_marker_fee = {
                  'id': '44803850993851',
                  'quantity': variant_qty,
                  'properties': {
                    'Customization Id': customizationIdFormatted,
                    'design-source' : designSource
                  }
                }
                
                if("design_ts" in a_variant['properties']){
                  ball_marker_fee['properties']['design_ts'] = a_variant['properties']['design_ts']
                }  

                // Push Form Data
                if(a_variant['properties']["customization-type"] == "embroidery"){
                  form_body.items.push(embroidery_fee) 
                } else if(a_variant['properties']["customization-type"] == "direct to garment"){
                  form_body.items.push(dtg_fee) 
                } else if(a_variant['properties']["customization-type"] == "heat"){
                  form_body.items.push(heat_transfer_fee)
                } else if(a_variant['properties']["customization-type"] == "sublimation"){
                  form_body.items.push(sublimation_fee)
                } else if(a_variant['properties']["customization-type"] == "direct to film"){
                  form_body.items.push(dtf_fee)
                } else {
                  if(this.isBallMarker){
                    form_body.items.push(ball_marker_fee)
                  } else {
                    form_body.items.push(customization_fee)
                  }
                }
            } else {
              if(isTeamStores && (customizable === 'false' || !customizable)) {
                const activeColorOption = document.querySelector('.color-option.active');  
                const nonCustomizableTeamStoreId = activeColorOption.querySelector('.color-swatch-box ').getAttribute('data-teamstore-id');
                a_variant['properties']['teamstore-id'] = nonCustomizableTeamStoreId
                form_body.items.push(a_variant)
              } else {
                form_body.items.push(a_variant)
              }
            }
          }
        }
      } 

      // Check items have been added to the form body. Throw error and return if none added.
      if(form_body.items.length == 0 ){
        alert("No Quantity Entered");
        // this.handleErrorMessage("No Quantity Entered")
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return
      }

      if (isCustomizedTemplate){
        const lineItemProperties = this.getTemplateCustomizationProperties()
        
        if ("Ball Pocket New Image" in lineItemProperties){
          const artSetup = {
            'id': '45117512122555',
            'quantity': 1,
            'properties': {
              'New Image': lineItemProperties["Ball Pocket New Image"],
              'customization-type': lineItemProperties["customization-type"],
            }
          }

          if("New Image" in lineItemProperties){
            artSetup["properties"]["Art Setup Id 2"] = `${customizationId}-2`
          } else {
            artSetup["properties"]["Art Setup Id"] = customizationId
          }
          form_body.items.push(artSetup)
        }
        // If New Image, add art setup fee
        else if("New Image" in lineItemProperties && lineItemProperties["customization-type"] == "embroidery"){
          const artSetup = {
            'id': '44219688681659',
            'quantity': 1,
            'properties': {
              'New Image': lineItemProperties["New Image"],
              'customization-type': lineItemProperties["customization-type"],
              "Art Setup Id": customizationId
            }
          }
          form_body.items.push(artSetup)
        }
        else if("New Image" in lineItemProperties){
          const artSetup = {
            'id': '45117512122555',
            'quantity': 1,
            'properties': {
              'New Image': lineItemProperties["New Image"],
              'customization-type': lineItemProperties["customization-type"],
              "Art Setup Id": customizationId
            }
          }
          form_body.items.push(artSetup)
        }
        
      }

      let form_data = this.convertToFormData(form_body)

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: form_data
      };

      // Important that the route is different for bulk orders because it returns relevant error information
      this.addItemsToCart(window.Shopify.routes.root + 'cart/add.js',config)
    }

    convertToFormData(aObject){
      let formData = new FormData()
      for (var key in aObject){
        if(key == 'items'){
          for(let item in aObject['items']){
            for(let itemAttribute in aObject['items'][item]){
              if(itemAttribute == 'properties'){
                for(let itemProperty in aObject['items'][item]['properties']){
                  formData.append(`items[${item}][properties][${itemProperty}]`, aObject['items'][item]['properties'][itemProperty])
                }
              }else {
                formData.append(`items[${item}][${itemAttribute}]`, aObject['items'][item][itemAttribute])
              }
            }
          }
        } else {
          formData.append(key, aObject[key])
        }
      }
      return formData
    }

    showLoading() {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    }

    showLoadingFDB() {
      this.formerDesignSubmitButton.setAttribute('aria-disabled', true);
      this.formerDesignSubmitButton.classList.add('loading');
      this.formerDesignSubmitButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    }

    hideLoading() {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    }

    hideLoadingFDB() {
      this.formerDesignSubmitButton.classList.remove('loading');
      this.formerDesignSubmitButton.removeAttribute('aria-disabled');
      this.formerDesignSubmitButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    }

    addSingleItem(formData, config) { 
      if (this.productType?.toLowerCase() === 'art setup fee') {
        const fileInput = document.querySelector('input[type="file"][name="properties[New Image]"]');
        if (!fileInput || fileInput.files.length === 0) {
          alert("Please upload a file before adding this Art Setup Fee to the cart.");
          // this.handleErrorMessage("Please upload a file before adding this Art Setup Fee to the cart.");
          this.hideLoading();
          return; // Stop Add-To-Cart
        }
      }
      // 1. Art Setup Fee
      if (this.productTitle.toLowerCase() == 'art setup fee') {
        formData.append("properties[Art Setup Id]", Date.now());
        config.body = formData;
        this.addItemsToCart(`${routes.cart_add_url}`, config);
        return; // ← STOP further execution
      }
      // 2. Quick Customization Art Setup Fee
      if (this.productTitle.toLowerCase() == 'quick customization art setup fee') {
        const customizationIdInput = document.getElementById('qc-customization-id');
        const customerId = customizationIdInput?.getAttribute('data-customer-id');
        const currentDate = customizationIdInput?.getAttribute('data-current-date');
        const currentTime = customizationIdInput?.getAttribute('data-current-time');
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => {
            const newCustomizationId = `${customerId}_mascot_${currentDate}${currentTime}`;
            formData.set('properties[Customization Id]', newCustomizationId);

            config.body = formData;
            this.addItemsToCart(`${routes.cart_add_url}`, config);
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
            config.body = formData;
            this.addItemsToCart(`${routes.cart_add_url}`, config);
          });
        return; // ← STOP further execution
      }
      // 3. Normal Add To Cart
      config.body = formData;
      this.addItemsToCart(`${routes.cart_add_url}`, config);
    }

    addItemsToCart(route, payload){
      fetch(route, payload)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          window.variantColorRadios = new VariantColorRadios();
          window.variantColorRadios.resetQty();
          alert(response.description);
          // this.handleErrorMessage(response.description);
          this.hideLoadingFDB();
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }
        
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cartNotification.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cartNotification.renderContents(response);
        }
        this.hideLoadingFDB();
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}